export const isInIframe = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.parent !== window;
  } catch {
    return true;
  }
};

/** Reading a cross-origin parent's location throws, so a throw means another origin embeds this frame. */
export const isEmbeddedByAnotherOrigin = (): boolean => {
  if (!isInIframe()) return false;
  try {
    return window.parent.location.origin !== window.location.origin;
  } catch {
    return true;
  }
};
